var _div, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFfw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 24,
    viewBox: "0 0 133.677 67.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _div || (_div = /*#__PURE__*/React.createElement("div", {
    xmlns: "",
    id: "in-page-channel-node-id",
    "data-channel-name": "in_page_channel_rcgQy_"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18",
    "data-name": "Pfad 18",
    d: "M.958,59.185l11.308.015,16.3-56.859-11.3-.015Z",
    transform: "translate(-0.958 -2.326)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_21",
    "data-name": "Pfad 21",
    d: "M3.184,61.6l11.3.015L30.795,4.751,19.489,4.738Z",
    transform: "translate(-3.184 -4.738)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_23",
    "data-name": "Pfad 23",
    d: "M2.58,53.911l2.827,0L18.92,6.789l-2.827,0Z",
    transform: "translate(-2.58 -6.785)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_25",
    "data-name": "Pfad 25",
    d: "M9.629,53.946,4.682,53.94l-1.5,5.221,4.946.009.009-.041,3.535,0L26.684,6.8,23.15,6.79Z",
    transform: "translate(-3.186 -6.79)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27",
    "data-name": "Pfad 27",
    d: "M3.876,53.913l4.946,0L22.336,6.793l-4.946-.007Z",
    transform: "translate(-3.876 -6.787)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_29",
    "data-name": "Pfad 29",
    d: "M10.072,9.207l4.946.007L16.3,4.745l-4.946,0Z",
    transform: "translate(-10.072 -4.741)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ffw-logo-white",
    transform: "translate(-30.832 -18.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    "data-name": "Pfad 16",
    d: "M104.733,14.735c-.111.321-3.666,13.694-5.069,18.963l-6.12-21.857H84.291L78.169,33.659,72.333,11.841H17.938V41.046a4.434,4.434,0,0,0,4.44,4.416h4.44V33.022H38.467v-8.1H26.819V19.906h15.84V45.46h8.885V33.02H63.193v-8.1H51.544V19.9H65.5l7.483,25.552H83.1l5.764-19.62,5.766,19.62h10.106l9.849-33.615h-5.64a4.533,4.533,0,0,0-4.209,2.894",
    transform: "translate(49.927 27.237)",
    fill: "#969697"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_26",
    "data-name": "Gruppe 26",
    transform: "translate(30.832 18.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_17",
    "data-name": "Pfad 17",
    d: "M28.569,2.341,12.264,59.2.958,59.187l16.3-56.862Z",
    transform: "translate(-0.958 -2.326)",
    fill: "#969697"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5",
    "data-name": "Gruppe 5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4",
    "data-name": "Gruppe 4",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_3",
    "data-name": "Rechteck 3",
    width: 25,
    height: 14.253,
    transform: "matrix(0.276, -0.961, 0.961, 0.276, -2.088, 58.021)",
    fill: "#969697"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_19",
    "data-name": "Pfad 19",
    d: "M16.355,28.942l-3.62,12.625L1.429,41.553,5.9,25.946Z",
    transform: "translate(-0.402 25.568)",
    fill: "#969697"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_20",
    "data-name": "Pfad 20",
    d: "M30.794,4.753,14.49,61.612,3.184,61.6l16.3-56.862Z",
    transform: "translate(1.67 0.523)",
    fill: "#969697"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_8",
    "data-name": "Gruppe 8",
    transform: "translate(4.855 5.261)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_5",
    "data-name": "Rechteck 5",
    width: 25,
    height: 14.253,
    transform: "matrix(0.276, -0.961, 0.961, 0.276, -2.089, 58.02)",
    fill: "#969697"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_22",
    "data-name": "Pfad 22",
    d: "M18.92,6.789,5.407,53.913l-2.827,0L16.093,6.785Z",
    transform: "translate(0.958 2.941)",
    fill: "#969697"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_13",
    "data-name": "Gruppe 13",
    transform: "translate(3.537 9.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_12",
    "data-name": "Gruppe 12",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_7",
    "data-name": "Rechteck 7",
    width: 25,
    height: 6.099,
    transform: "matrix(0.276, -0.961, 0.961, 0.276, -2.091, 48.284)",
    fill: "#969697"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_24",
    "data-name": "Pfad 24",
    d: "M8.132,59.168l-4.946-.007,1.5-5.221,4.946.007L23.15,6.79l3.533,0L11.676,59.133l-3.533,0Z",
    transform: "translate(1.673 2.947)",
    fill: "#969697"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_17",
    "data-name": "Gruppe 17",
    transform: "translate(4.859 9.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_16",
    "data-name": "Gruppe 16",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_9",
    "data-name": "Rechteck 9",
    width: 25,
    height: 11.535,
    transform: "translate(-2.093 53.53) rotate(-73.998)",
    fill: "#969697"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26",
    "data-name": "Pfad 26",
    d: "M22.336,6.794,8.822,53.917l-4.946-.007L17.389,6.787Z",
    transform: "translate(2.488 2.943)",
    fill: "#969697"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_20",
    "data-name": "Gruppe 20",
    transform: "translate(6.364 9.729)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_11",
    "data-name": "Rechteck 11",
    width: 25,
    height: 8.136,
    transform: "translate(-2.087 48.284) rotate(-74.004)",
    fill: "#969697"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_28",
    "data-name": "Pfad 28",
    d: "M16.3,4.747l-1.28,4.467-4.946-.007,1.28-4.467Z",
    transform: "translate(9.805 0.526)",
    fill: "#969697"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_25",
    "data-name": "Gruppe 25",
    transform: "translate(19.877 5.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_24",
    "data-name": "Gruppe 24",
    transform: "translate(0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_13",
    "data-name": "Rechteck 13",
    width: 25,
    height: 8.137,
    transform: "translate(-2.091 5.626) rotate(-74.008)",
    fill: "#969697"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfw);
export default __webpack_public_path__ + "static/media/ffw.7b51dd322e2ac22aba8c7d96a85a55ea.svg";
export { ForwardRef as ReactComponent };